import Vue from 'vue'
import Router from 'vue-router'

import Homepage from '@/components/pages/Homepage.vue'
import NotFoundPage from '@/components/pages/404.vue'

Vue.use(Router)

export default new Router({
  mode: 'history',
  routes: [
    {
      path: '/',
      name: 'Homepage',
      component: Homepage
    },
    {
      name: 'NotFound',
      path: '*',
      component: NotFoundPage
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js